import Service, { getCallApiFunction } from '../service'
// import denormalizer from './denormalizer'
// import normalizer from './normalizer'

export type ParamsType = {
  merchantId: string
  size?: number
}

class FetchProductListApi extends Service {
  constructor(params: ParamsType) {
    super()
    this.name = 'FETCH_PRODUCT_LIST'

    this.config = {
      url: `/v1/product/merchant/${params.merchantId}`,
      params: {
        size: params.size,
      },
      method: 'GET',
    }
  }
}

export type ProductListType = {
  productsInfo: {
    isShow: boolean
    productInfo: ProductInfoType
    skuItemInfo: SkuItemInfoType[]
    specMenu: MenuType[]
  }[]
}

export type MenuType = {
  name: string
  values: {
    picture: string
    value: string
    attrId: number
  }[]
}

export type SkuItemInfoType = {
  skuId: number
  skuNo: string
  stockQuantity: number
  salePrice: number
  origPrice: number
  livePrice: number
  currency: string
  profile: {
    specs: { skuSpecName: string; skuSpecValue: string; nameSort: number; valueSort: number; picture: string; attrId: number; specId: number }[]
    images: string[]
  }
}

export type ProductInfoType = {
  merchantId?: number
  merchantName?: string
  categoryId?: number
  categoryName?: string
  productId?: number
  productName?: string
  productDesc?: string
  tags?: null
  minPrice?: number
  maxPrice?: number
  status?: number
  saleQuantity?: number
}

export const fetchProductList = (params: ParamsType) => getCallApiFunction(new FetchProductListApi(params))
